import * as React from 'react';
import {Button} from "semantic-ui-react";

interface OwnProps {
  hasSuggestions: boolean;
  onSuggest: () => void;
  pointDirection?: 'up' | 'down';
}

type CodySuggestButtonProps = OwnProps;

const CodySuggestButton = (props: CodySuggestButtonProps) => {
  const pointDirection = props.pointDirection || 'up';

  return <Button basic={true}
                 compact={true}
                 icon={`arrow alternate circle ${pointDirection}`}
                 className="noborder"
                 content={'Cody Suggest'} disabled={!props.hasSuggestions} onClick={() => props.onSuggest()} />
};

export default CodySuggestButton;
